import { dateStringRegEx } from './dateStringRegEx';

/**
 * Checks if a string is a valid date string; i.e. matches the pattern: '2020-01-31'
 * @param str any string
 */
export function isValidDateString(str: string): str is DateString {
    return str.match(dateStringRegEx) !== null;
}
